module.exports = __webpack_public_path__ + "lr.33d2b86d90703ba4f187.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/lr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/lr.svg
// module chunks = styles